import React, { useEffect, useState } from "react";
import { Form, Link, NavLink, useNavigate } from "react-router-dom";
import FloatingLabelInput from "./FloatingLabelInput";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { FcGoogle } from "react-icons/fc";
import { SignInImages, people } from "../config/imagesLink";
// import { Register, TestApi } from '../Services/Service'
import { useFormik } from "formik";
import { registerValidations } from "./Validations";
import axios, { PublicKey } from "../API/axios";
import { GA_MEASUREMENT_ID } from "../config/appConfig";
import fetch_axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import { useToaster } from "react-hot-toast";
import SuccessToast from "./SuccessToast";
import WarningToast from "./WarningToast";
import ErrorToast from "./ErrorToast";
import { getAuth, signInWithPopup, OAuthProvider } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { Button, Dropdown } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import TranslateIcon from '@mui/icons-material/Translate';


const shouldEnableFirebaseAnalytics = (() => {
  if (process.env.NODE_ENV !== "production") return false;
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  const isProdHost =
    host === "welinkjobs.com" ||
    (host.endsWith(".welinkjobs.com") && !host.startsWith("preprod."));
  return isProdHost;
})();


const firebaseConfig = {
  apiKey: "AIzaSyD8GJvS-To2H4dOM8lbn5JRUQVhCL8uxJM",
  authDomain: "welinkjobs-23583.firebaseapp.com",
  projectId: "welinkjobs-23583",
  storageBucket: "welinkjobs-23583.appspot.com",
  messagingSenderId: "375220227786",
  appId: "1:375220227786:web:bb1fd63622ce66d4936e33",
  ...(shouldEnableFirebaseAnalytics
    ? { measurementId: GA_MEASUREMENT_ID }
    : {}),
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const SignUp = () => {
  const { success } = useToaster();
const { t } = useTranslation();
  const navigate = useNavigate();
  const [User_Name, setuserName] = useState("");
  const [Response_Message, setmessage] = useState("");
 const language = localStorage.getItem("Lang");
  const [currentLang, setCurrentLang] = useState(i18n?.language || language || "en");
  //************************ Country Flag code start  ************************//

  // const [items, setItems] = useState([]);

  // useEffect(() => {
  //     fetch(
  //         "https://raw.githubusercontent.com/iamspruce/search-filter-painate-reactjs/main/data/countries.json"
  //     )
  //         .then((res) => res.json())
  //         .then(
  //             (result) => {
  //                 // setLoaded(true);
  //                 setItems(result);
  //                 // console.log(result);
  //             },
  //             (error) => {
  //                 // setLoaded(true);
  //                 // setError(error);
  //             }
  //         );
  // }, []);
  // const data = Object.values(items);

  // const [isOpen, setIsOpen] = useState(false);
  // const [selectedItem, setSelectedItem] = useState(null);
  // const [searchTerm, setSearchTerm] = useState('');
  // // console.log('selectedItem', selectedItem.callingCode);
  // const filteredData = data.filter(item =>
  //     item.name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  // const handleItemClick = (item) => {
  //     setSelectedItem(item);
  //     setIsOpen(false);
  // };
  //************************ Country Flag code End  ************************//

  //************************ Register With Email Start  ************************//

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [userID, setuserID] = useState("");
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [otp, setOtp] = useState("");
  const handleChangeOtp = (otp) => setOtp(otp);
  const getResponseMessage = (response, fallback = "Success") =>
    response?.data?.message || response?.message || fallback;
  const getErrorMessage = (error, fallback = "Something went wrong") =>
    error?.response?.data?.message || error?.message || fallback;
  const resetToasts = () => {
    setShowToast(false);
    setToastMessage("");
    setShowWarningToast(false);
    setWarningToastMessage("");
    setShowErrorToast(false);
    setErrorToastMessage("");
  };

  const initialValues = {
    mail: "",
    password: "",
    confirmPassword: "",
    register_checkbox: false,
  };
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);

  const toggleConfirmPasswordVisibility = () => {
    setshowConfirmPassword(!showConfirmPassword);
  };
  // console.log("res", sessionId, userID);

  const { values, errors, handleBlur, touched, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: registerValidations,
      onSubmit: async () => {
        setLoading(true);
        resetToasts();
        const RegisterData = {
          deviceType: "Web",
          email: values.email,
          password: values.password,
          confirmPassword: values.confirmPassword,
          firstName: values.firstname,
          lastName: values.lastname,
          langKey: language === "en" ? "" : language,

        };

        try {
          await axios
            .post("OAuth/RegisterWithEmail", RegisterData, {
              headers: {
                PublicKey,
              },
            })
            .then((response) => {
              // debugger;
              localStorage.setItem("Lang", language === null ? "en" : language);
              const responseMessage = getResponseMessage(response);

              if (response.status === "Success") {
                const responseNew = response.responseData.profile;
                const userRole = response.responseData.userRoles;
                setToastMessage(responseMessage);
                setShowToast(!!String(responseMessage).trim());
                setuserID(response.data.responseData.userId);
                console.log("Response New", response.responseData);
                localStorage.setItem("user-Id", responseNew.id);
                localStorage.setItem("userUid", responseNew.userUid);
                localStorage.setItem("user-email", responseNew.email);
                localStorage.setItem("user-nameTag", responseNew.nameTag);
                localStorage.setItem("user-profilPic", responseNew.profilPic);
                localStorage.setItem("user-referCode", responseNew.referCode);
                localStorage.setItem("sessionId", responseNew.sessionId);
                localStorage.setItem("token", responseNew.token);
                localStorage.setItem("loginType", responseNew.loginType);
                localStorage.setItem("profilPic", responseNew.profilPic);
                localStorage.setItem("firstName", responseNew.firstName);
                localStorage.setItem("lastName", responseNew.lastName);
                localStorage.setItem("userRole", userRole);
                setSessionId(response.data.responseData.sessionID);


                localStorage.removeItem("guestMode");
                setTimeout(() => {
                  navigate("/Newsfeed");
                }, 2000);
              } else {
                setToastMessage(responseMessage);
                setShowToast(!!String(responseMessage).trim());
                setFlag(true);
                setuserName(response.data.responseData.userName);
                setmessage(responseMessage);
                setSessionId(response.data.responseData.sessionID);
                setuserID(response.data.responseData.userId);
              }
            });
        } catch (error) {
          // debugger;
        localStorage.setItem("Lang", language === null ? "en" : language);
          const errorMessage = getErrorMessage(error);

          if (error.response && error.response.status === 403) {
            setToastMessage(errorMessage);
            setShowToast(!!String(errorMessage).trim());
            setFlag(true);
            setuserName(error.response.data.responseData.userName);
            setmessage(errorMessage);
            setSessionId(error.response.data.responseData.sessionID);
            setuserID(error.response.data.responseData.userId);
          } else if (error.response && error.response.status === 404) {
            setWarningToastMessage(errorMessage);
            setShowWarningToast(true);
          } else {
            setErrorToastMessage(errorMessage);
            setShowErrorToast(true);
          }
        } finally {
          setLoading(false);
        }
      },
    });
  const otpCheck = async (e) => {
    e.preventDefault();
    resetToasts();
    try {
      // console.log("OTP:", otp);
      // console.log("SessioID:", sessionId);
      // console.log("UserID:", userID);

      await axios
        .post(
          `OAuth/ConfirmAccountByOTP?OTP=${otp}&SessionID=${sessionId}&UserID=${userID}&DeviceType=Web`,
          { headers: { PublicKey } }
        )

        .then((res) => {
          console.log("res", res);
          const responseMessage = getResponseMessage(res);
          setToastMessage(responseMessage);
          setShowToast(!!String(responseMessage).trim());
          setFlag(false);

          const data = res.data.responseData;
          const response = res.data.responseData.profile;
          const userRole = res.data.responseData.userRoles;
          localStorage.setItem("Lang", language === null ? "en" : language);

          localStorage.setItem("user-Id", response.id);
          localStorage.setItem("userUid", response.userUid);
          localStorage.setItem("user-email", response.email);
          localStorage.setItem("user-nameTag", response.nameTag);
          localStorage.setItem("user-profilPic", response.profilPic);
          localStorage.setItem("user-referCode", response.referCode);
          localStorage.setItem("sessionId", response.sessionId);
          localStorage.setItem("token", response.token);
          localStorage.setItem("loginType", response.loginType);
          localStorage.setItem("profilPic", response.profilPic);
          localStorage.setItem("firstName", response.firstName);
          localStorage.setItem("lastName", response.lastName);
          localStorage.setItem("userRole", userRole);
          
          localStorage.setItem("engagedUsersMostEngagedPostIds", data.algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", data.algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", data.algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", data.algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", data.algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", data.algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", data.algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", data.algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", data.algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", data.algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", data.algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", data.algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", data.algoData.ownedAllPostIds)

          localStorage.removeItem("guestMode");
          setTimeout(() => {
            navigate("/Newsfeed");
          }, 2000);
          // if (res.data.length === 0) {

          // } else {
          //   toast.error("Wrong OTP");
          // }
        });
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Register With Email End  ************************//

  //************************ Register With Google Start  ************************//
  const [googleloading, setGoogleloading] = useState(false);

  const externalLogin = async (responseData) => {
    setGoogleloading(true);
    resetToasts();
    try {
      const response = await (
        await axios.post("OAuth/RegisterWithGoogle", responseData, {
          headers: {
            PublicKey,
          },
        })
      ).data;
      console.log("google response", response);
      localStorage.setItem("Lang", language === null ? "en" : language);

      if (response.status === "Success") {
        const responseNew = response.responseData.profile;
        const userRole = response.responseData.userRoles;
        setToastMessage(response.message || "Success");
        setShowToast(!!String(response.message || "Success").trim());
        localStorage.setItem("Lang", language === null ? "en" : language);
        localStorage.setItem("user-Id", responseNew.id);
        localStorage.setItem("userUid", responseNew.userUid);
        localStorage.setItem("user-email", responseNew.email);
        localStorage.setItem("user-nameTag", responseNew.nameTag);
        localStorage.setItem("user-profilPic", responseNew.profilPic);
        localStorage.setItem("user-referCode", responseNew.referCode);
        localStorage.setItem("sessionId", responseNew.sessionId);
        localStorage.setItem("token", responseNew.token);
        localStorage.setItem("loginType", responseNew.loginType);
        localStorage.setItem("profilPic", responseNew.profilPic);
        localStorage.setItem("firstName", responseNew.firstName);
        localStorage.setItem("lastName", responseNew.lastName);
        localStorage.setItem("userRole", userRole);

        localStorage.removeItem("guestMode");
        setTimeout(() => {
          navigate("/Newsfeed");
        }, 2000);
      } else {
        localStorage.setItem("Lang", language === null ? "en" : language);
        console.log("Lang", language === null ? "en" : language);
        
        setToastMessage(response.message || "Success");
        setShowToast(!!String(response.message || "Success").trim());
        setFlag(true);
        setuserName(response.data.responseData.userName);
        setmessage(response.data.message);
        setSessionId(response.responseData.sessionID);
        setuserID(response.responseData.userID);
      }
      // toast.success(response.message);
      // navigate("/SignIn");
    } catch (error) {
        localStorage.setItem("Lang", language === null ? "en" : language);
      const errorMessage = getErrorMessage(error);

      if (error.response && error.response.status === 403) {
        setToastMessage(errorMessage);
        setShowToast(!!String(errorMessage).trim());
        setFlag(true);
        setuserName(error.response.data.responseData.userName);
        setmessage(errorMessage);
        setSessionId(error.response.data.responseData.sessionID);
        setuserID(error.response.data.responseData.userID);
      } else if (error.response && error.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    } finally {
      setGoogleloading(false);
    }
  };
  const googleSignin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      // setIsLoading(false);
      try {
        const resp = await fetch_axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        const responseData = {
          deviceType: "Web",
          email: resp.data.email,
          externalLoginId: resp.data.sub,
          loginType: "Google",
          firstName: resp.data.given_name,
          lastName: resp.data.family_name,
          // profilPic: resp.data.picture,
        };
        externalLogin(responseData);
        // setIsLoading(true);
        // navigate("/NewsFeeds");
      } catch (error) {
        console.log(error);
        // setIsLoading(true);
      }
    },
  });
  //************************ Register With Google End  ************************//

  // Load Apple Sign-In script
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleAppleSignIn = () => {
    try {
      if (window.AppleID) {
        window.AppleID.auth.init({
          clientId: "com.welinkjob.welink",
          scope: "email",
          redirectURI: "https://v2-web-app-pd29.vercel.app/signIn",
          state: "4ee08dcf-73ac-4569-7336-4e5d867b0599",
          usePopup: true,
        });

        window.AppleID.auth
          .signIn()
          .then((response) => {
            console.log("response", response); // Handle the response from Apple
          })
          .catch((error) => {
            console.error("Sign-In Error:", error); // Handle sign-in errors
          });
      } else {
        console.error(
          "AppleID is not defined. Ensure the script is loaded correctly."
        );
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  };

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [originalemail, setOriginalEmail] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const [externalEmail, setExernalEmail] = useState("");

  const [showModal, setShowModal] = useState(false);
  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);

  const RegisterWithApple = async () => {
    const provider = new OAuthProvider("apple.com");
    provider.addScope("email");
    provider.addScope("name");

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      // const credential = OAuthProvider.credentialFromResult(result);
      // const accessToken = credential.accessToken;
      console.log("accessToken", user);
      setFirstName(user.displayName?.split(" ")[0]);
      setLastName(user.displayName?.split(" ")[1]);
      setExernalEmail(user.email);
      setAccessToken(user.accessToken);
      setPhotoUrl(user.photoURL);
      handleModalOpen();
    } catch (error) {
      console.error("Error signing in with Apple:", error);
    }
  };

  const _registerWithAppleApi = async () => {
    try {
      const responseData = {
        deviceType: "Web",
        appleAccessToken: accessToken,
        loginType: "Apple",
        email: originalemail,
        langKey: language === "en" ? "" : language,

      };
      if (originalemail !== "" && firstName !== "" && lastName !== "") {
        const response = await axios.post(
          "OAuth/RegisterWithApple",
          responseData,
          {
            headers: {
              PublicKey,
            },
          }
        );
        localStorage.setItem("Lang", language === null ? "en" : language);

        if (response.status === "Success") {
          const responseNew = response.responseData.profile;
          const userRole = response.responseData.userRoles;
          setToastMessage(response.data.message);
          setShowToast(true);
          localStorage.setItem("user-Id", responseNew.id);
          localStorage.setItem("userUid", responseNew.userUid);
          localStorage.setItem("user-email", responseNew.email);
          localStorage.setItem("user-nameTag", responseNew.nameTag);
          localStorage.setItem("user-profilPic", responseNew.profilPic);
          localStorage.setItem("user-referCode", responseNew.referCode);
          localStorage.setItem("sessionId", responseNew.sessionId);
          localStorage.setItem("token", responseNew.token);
          localStorage.setItem("loginType", responseNew.loginType);
          localStorage.setItem("profilPic", responseNew.profilPic);
          localStorage.setItem("firstName", responseNew.firstName);
          localStorage.setItem("lastName", responseNew.lastName);
          localStorage.setItem("userRole", userRole);

          localStorage.removeItem("guestMode");
          setTimeout(() => {
            navigate("/Newsfeed");
          }, 2000);
        } else {
          setToastMessage(response.data.message);
          setShowToast(true);
          setFlag(true);
          setuserName(response.data.responseData.userName);
          setmessage(response.data.message);
          setSessionId(response.data.responseData.sessionID);
          setuserID(response.data.responseData.userId);
        }
      } else {
        setErrorToastMessage(t("modals.Please fill all the required fields"));
        setShowErrorToast(true);
      }
    } catch (error) {
      console.error("Error during registration:", error);
      setErrorToastMessage(error.response.data.message);
      setShowErrorToast(true);
    }
  };
  const [ConnectionListForGuest, setConnectionListForGuest] = useState("");
  const ConnectionListAllForGuest = async (id) => {
    try {
      await axios
        .get("UserFollow/GetMostFollowingUser?DeviceType=Web")
        .then((resData) => {
          // console.log("ConnectionListAllForGuest", resData.data.responseData);
          setConnectionListForGuest(resData.data.responseData);
        });
    } catch (error) {
      console.log(error);
    }
  }; 
  useEffect(() => {
    ConnectionListAllForGuest();
  }, []);
  const [guestMode, setGuestMode] = useState(false);
  const LinktoGuest = () => {
    setGuestMode(true);
    localStorage.setItem("guestMode", "true");
  };

  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(30);
  const resendOTP = async (e) => {
      if (seconds > 0 || minutes > 0) return;
      setMinutes(1);
      setSeconds(30);
      e.preventDefault();
    try {
      await axios.post(`OAuth/ResendOTP?UserID=${userID}`).then((res) => {
        console.log("res", res);
        setSessionId(res.data.responseData.sessionID);
        setToastMessage(res.data.message);
        setShowToast(true);
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    if (showModal || flag) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showModal, flag]);

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem("Lang", lang);
        setCurrentLang(lang);

        // document.body.dir = lang === "ar" ? "rtl" : "ltr"; // RTL for Arabic
      };
  return (
    <>
     <style>
        {
          `.language-dropdown .dropdown-menu {
            transform: none !important;
            inset: auto !important;
            right: 10px !important;
            bottom: 40px !important;
    }
`
        }
      </style>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8 full-height p-2 loginImage">
            <div className="bg-cover">
              <div className="imageData">
                <div className="text-center">
                  <img src={SignInImages.whiteLogo} alt="" />
                </div>
                <p>
                  {t("SignIn.Stay connected for")} <NavLink
                    to={`/SearchJob`}
                    onClick={LinktoGuest}
                    className="border-bottom"
                  >
                    {t("Company Profile.Jobs")} </NavLink>{" "}
                  {t("SignIn.and")} <NavLink
                    to={`/NewsFeed`}
                    onClick={LinktoGuest}
                    className="border-bottom"
                  >
                    {t("SignIn.More")}
                  </NavLink>
                </p>
                {/* <div className="text-center mt-4">
                  <img src={SignInImages.ovalwithtext} alt="" width="80%" />
                </div> */}
                {/* <div className="userLink text-center mt-4 d-flex justify-content-center">
                  <Link to='/People' onClick={LinktoGuest} >
                    <div className="circle-container">
                      {ConnectionListForGuest && ConnectionListForGuest?.slice(0, 3).map((user, userIndex) => (
                        <img
                          src={user?.profilPic}
                          alt={`Circle ${userIndex + 1}`}
                          className="circle-img"
                          key={userIndex}
                        />
                      ))}
                    </div>
                  </Link>
                  <span className="f-14">12k+ people joined us, now it's your turn</span>
                </div> */}
                <div className="userLink text-center mt-2 d-flex justify-content-center">
                  <Link to="/People" onClick={LinktoGuest}>
                    <div className="circle-container">
                      {ConnectionListForGuest &&
                        ConnectionListForGuest?.slice(0, 3).map(
                          (user, userIndex) => (
                            <img
                              src={user?.profilPic}
                              alt={`Circle ${userIndex + 1}`}
                              className="circle-img"
                              key={userIndex}
                              onError={handleProfileImageError}
                            />
                          )
                        )}
                    </div>
                  </Link>
                  <span className="f-14 fw-bold">
                   {t("SignIn.15k+ people joined us, now it's your turn")}
                  </span>
                  {/* <img src={SignInImages.ovalwithtext} alt="" width="80%" /> */}
                </div>
                <div className="socialLogin d-flex justify-content-evenly pt-3">
               
                <a href="https://bit.ly/welinkjobsapp" target="_blank">
                  <img src={SignInImages.playstore} alt="" width="130px" />
                </a>
                <a href="https://bit.ly/welinkjobs-iOS" target="_blank">
                  <img src={SignInImages.appstore} alt="" width="130px" />
                </a>
              </div> 
              </div>
              <div className="linksHelp">
                                <p><a href="/privacy-policy.html" target='_blank'>{t("Sidemenubar.Privacy Policy")} </a> | 
                                <a href="/terms-and-conditions.html" target='_blank'>
                                {t("Sidemenubar.Terms & Conditions")}</a></p>
                                <p className='d-flex'>{t("SignIn.Having Troubles")}? <a href="/faq.html" className='border-bottom me-3 ms-1' target='_blank'>
                                {t("SignIn.Get Help")}</a>
                                  <Dropdown className="language-dropdown">
                                                  <Dropdown.Toggle
                                                    id="language-toggle"
                                                    variant="link"
                                                    className="text-decoration-none p-0 d-flex align-items-center language-btn"
                                                    style={{transform:"none !important"}}
                                                  >
                                                    {/* <Globe size={18} className="me-1" /> */}
                                                  <TranslateIcon className="material-symbols-sharp me-3" 
                                                  //  style={{ color: "white", position: "relative", top: "1px" }}
                                                   style={{left: "20%", fill: "white"}}
                                                  />
                                                    {/* <span>{t("Language")}</span> */}
                                                  </Dropdown.Toggle>
                                
                                                  <Dropdown.Menu align="end">
                                                    {["en", "hi", "ar"].map((lang) => (
                                                      <Dropdown.Item
                                                        key={lang}
                                                        as="button"
                                                        style={{ width: "150px" }}
                                                        onClick={() => changeLanguage(lang)}
                                                      >
                                                        <div className="d-flex justify-content-between align-items-center w-100">
                                                          <span>{lang === "en" ? "English" : lang === "hi" ? "Hindi" : "Arabic"}</span>
                                                          {currentLang === lang && (
                                                            <span style={{ color: "#0d6efd", fontWeight: 600 }}>✓</span>
                                                          )}
                                                        </div>
                                                      </Dropdown.Item>
                                                    ))}
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                                 </p>
                            </div>
            </div>
          </div>
          <div className="col-md-4 SignUpSec p-2">
            <div className="form-container pb-3">
              <p className="f-20 mb-2 text-center borderSignUp">
                {t("SignIn.Already have an account")}? <Link to="/SignIn">{t("SignIn.Sign in")}</Link>
              </p>

              <div className="formBorder p-1">
                <p className="ms-1">
                  {t("SignIn.By clicking Sign Up")}
                  <NavLink className="ms-1" to="/terms-and-conditions.html" target="blank">
                    {t("Sidemenubar.Terms & Conditions")}
                  </NavLink>{" "}
                  {t("SignIn.and")}
                  <NavLink className="ms-1" to="/privacy-policy.html" target="blank">
                    {t("Sidemenubar.Privacy Policy")}
                  </NavLink>
                </p>

                <Form onSubmit={handleSubmit}>
                  <div className="checker d-flex align-items-center mt-2">
                    {/* <input
                      type="checkbox"
                      id="terms"
                      name="register_checkbox"
                      value={values.register_checkbox}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    /> */}
                  </div>
                  {errors.register_checkbox && touched.register_checkbox ? (
                    <p className="form-error" style={{ color: "red" }}>
                      {errors.register_checkbox}
                    </p>
                  ) : null}
                  <h2 className="fw-bold text-center f-22 SigninHeading">
                     {t("SignIn.Sign Up")}
                  </h2>
                   <div className="Increasewidth border-signIn d-flex align-items-baseline mt-3">
                  <FloatingLabelInput
                    id="email"
                    label={t("Manage Companies.Email Id")}
                    type="text"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="custom-input"
                  />
                  </div>
                  {errors.email && touched.email && (
                    <p className="form-error" style={{ color: "red" }}>
                      {errors.email}
                    </p>
                  )}
                  
                  <div className="Increasewidth border-signIn d-flex align-items-baseline mt-3">
                    <FloatingLabelInput
                      id="firstname"
                      label={t("Newsfeed.First Name")} 
                      type="text"
                      name="firstname"
                      value={values.firstname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="custom-input"
                    />
                  </div>
                  {errors.firstname && touched.firstname ? (
                    <p className="form-error" style={{ color: "red" }}>
                      {errors.firstname}
                    </p>
                  ) : null}
                  
                  <div className="Increasewidth border-signIn d-flex align-items-baseline mt-3">
                    <FloatingLabelInput
                      id="lastname"
                      label={t("Newsfeed.Last Name")} 
                      type="text"
                      name="lastname"
                      value={values.lastname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="custom-input"
                    />
                  </div>
                  {errors.lastname && touched.lastname ? (
                    <p className="form-error" style={{ color: "red" }}>
                      {errors.lastname}
                    </p>
                  ) : null}
                  
                  <div className="password-input border-signIn d-flex align-items-baseline mt-3">
                    <FloatingLabelInput
                      id="password"
                      label={t("SignIn.Password")}
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <div
                      className="password-toggle"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </div>
                  </div>
                  {errors.password && touched.password && (
                    <p className="form-error" style={{ color: "red" }}>
                      {errors.password}
                    </p>
                  )}

                  <div className="password-input border-signIn d-flex align-items-baseline mt-3">
                    <FloatingLabelInput
                      id="confirmPassword"
                      label={t("SignIn.Confirm Password")} 
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      value={values.confirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <div
                      className="password-toggle"
                      onClick={toggleConfirmPasswordVisibility}
                    >
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </div>
                  </div>
                  {errors.confirmPassword && touched.confirmPassword ? (
                    <p className="form-error" style={{ color: "red" }}>
                      {errors.confirmPassword}
                    </p>
                  ) : null}

                  <div className="my-4 text-center">
                    <button
                      type="submit"
                      className="mainBtn"
                      disabled={
                        !values.email ||
                        !values.password ||
                        !values.confirmPassword ||
                        // !values.register_checkbox ||
                        loading
                      }
                    >
                      {loading ? `${t("SignIn.Loading")}` : `${t("SignIn.Sign Up")}`}
                    </button>
                  </div>
                </Form>
                {/* <Form
                  className="auth-register-form mt-1 phoneSignUp pt-2"
                  onSubmit={otpCheck}
                  style={{ display: flag ? "block" : "none" }}
                >
                  <div className="mb-1 d-flex justify-content-center otp-input">
                    <OtpInput
                      value={otp}
                      onChange={handleChangeOtp}
                      numInputs={6}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>

                  <div className="text-center mt-3">
                    <button
                      type="submit"
                      className="mainBtn"
                    >
                      {loading ? "loading..." : "Verify OTP"}
                    </button>
                  </div>
                </Form> */}
                <div className="divider">{t("SignIn.or")}</div>
                <div className="socialLogin d-flex justify-content-between pt-2 pb-2 gap-4">
                  <button
                    className="socialBtn"
                    onClick={googleSignin}
                    disabled={googleloading}
                    // disabled={!values.register_checkbox || googleloading}
                  >
                    <img src={SignInImages.google} alt="google" />
                    <p>
                      {googleloading ? `${t("SignIn.Loading")}` : `${t("SignIn.Sign up with Google")}`}{" "}
                    </p>
                  </button>
                  {/* <button className="socialBtn">
                  <img src={SignInImages.facebook} alt="facebook" />
                  <p>Facebook</p>
                </button> */}
                  {/* <button className="socialBtn" onClick={handleAppleSignIn} disabled={!values.register_checkbox}>
                  <img src={SignInImages.icloud} alt="icloud" />
                  <p>iCloud</p>
                </button> */}

                  <button
                    className="socialBtn"
                    onClick={RegisterWithApple}
                    // disabled={!values.register_checkbox}
                  >
                    <img src={SignInImages.apple} alt="google" width={20} />
                    <p>{t("SignIn.Sign up with Apple")}</p>
                  </button>
                </div>
              </div>

              {/* <div className="divider my-3">Apps</div> */}
              {/* <div className="socialLogin d-flex justify-content-evenly pt-2">
               
                <a href="https://bit.ly/welinkjobsapp" target="_blank">
                  <img src={SignInImages.playstore} alt="" width="150px" />
                </a>
                <a href="https://bit.ly/welinkjobs-iOS" target="_blank">
                  <img src={SignInImages.appstore} alt="" width="150px" />
                </a>
              </div> */}
              {/* <div className="checker">
                <p className="border-top mt-2">
                  Protected by reCAPTCHA and subject to the{" "}
                  <NavLink to="/privacy-policy.html" target="blank">
                    Privacy Policy
                  </NavLink>
                  and{" "}
                  <NavLink to="/terms-and-conditions.html" target="blank">
                    Terms of Service.
                  </NavLink>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <SuccessToast
        show={showToast && !!String(toastMessage || "").trim()}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {showModal && (
        <div
          className="modal fade show modal-md"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="p-2 pt-4 text-center">
                <h6>Hi </h6>
                <p>
                  Please provide an email address to complete your WLJ profile
                  with associated apple account
                </p>
              </div>
              <Form>
                <div className="row modal-p settings CreateCompany">
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      Email
                      <span className="text-danger ms-2">*</span>
                    </label>
                    <input
                      type="text"
                      value={originalemail}
                      onChange={(e) => setOriginalEmail(e.target.value)}
                    />
                  </div>

                  <div className="text-end mt-4">
                    <button
                      type="button"
                      className="closebtn me-2"
                      onClick={handleModalClose}
                      style={{ width: "60px" }}
                    >
                      {t("User Profile.Close")}
                    </button>
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={_registerWithAppleApi}
                      // style={{ width: "70px" }}
                    >
                      {t("User Profile.Submit")}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
      {flag && (
        <div
          className="modal fade show modal-md"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="p-2 pt-4 text-center">
                <h4>Hi {User_Name},</h4>
                <h6>
                  <span className="fw-bold signUpModal">
                    Verify account by OTP
                  </span>{" "}
                </h6>
                <p>{Response_Message}</p>
              </div>
              <Form
                className="auth-register-form mt-1 phoneSignUp pt-2 pb-3"
                onSubmit={otpCheck}
                style={{ display: flag ? "block" : "none" }}
              >
                <div className="mb-1 d-flex justify-content-center otp-input">
                  <OtpInput
                    value={otp}
                    onChange={handleChangeOtp}
                    numInputs={4}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>

                <div className="text-center mt-3">
                  <div className="countdown-text d-flex justify-content-center">
                    {seconds > 0 || minutes > 0 ? (
                      <p className="me-3">
                        Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}
                        :{seconds < 10 ? `0${seconds}` : seconds}
                      </p>
                    ) : (
                      <p className="me-3">Didn't recieve code?</p>
                    )}

                    <span
                      style={{
                        color:
                          seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                        pointerEvents: seconds > 0 || minutes > 0 ? "none" : "auto",
                        cursor: seconds > 0 || minutes > 0 ? "not-allowed" : "pointer",
                      }}
                      onClick={resendOTP}
                      className={seconds > 0 || minutes > 0 ? "" : "pointer"}
                    >
                      Resend OTP
                    </span>
                  </div>
                  <button type="submit" className="mainBtn mt-3">
                    {loading ? "loading..." : "Verify OTP"}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignUp;
